const EMAIL_ADDRESS_PATTERN: RegExp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\.+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function isEmailAddress(value: string): boolean {
	return EMAIL_ADDRESS_PATTERN.test(value);
}

export {
	isEmailAddress,
	EMAIL_ADDRESS_PATTERN
};
